import api from "services/api";

export const createChat = async (payload) => {
  try {
    const formData = new FormData();

    if (payload.sender_id) formData.append("sender_id", payload.sender_id);
    if (payload.receiver_id) formData.append("receiver_id", payload.receiver_id);
    if (payload.chat_type) formData.append("chat_type", payload.chat_type);
    if (payload.message) formData.append("message", payload.message);
    if (payload.location) formData.append("location", payload.location);

    if (payload.images && payload.images.length > 0) {
      payload.images.forEach((img) => {
        formData.append("images", img);
      });
    }

    if (payload.documents && payload.documents.length > 0) {
      payload.documents.forEach((doc) => {
        formData.append("documents", doc);
      });
    }
    const response = await api.post("/chat-management/chats/", formData);

    if (response.status === 201 || response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    console.error("Chat creation error:", error.response?.data || error.message);
    return { success: false, error: error.response?.data?.detail || "Chat creation failed" };
  }
};


export const getChatBetweenUsers = async (otherUserId) => {
  try {
    // Construct the URL to get the chat between users
    const response = await api.get(`/chat-management/chats/between/${otherUserId}`);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" }; 
    }
  } catch (error) {
    console.error("Error getting chat between users:", error);
    return { success: false, error: error.message || "Failed to fetch chat" };
  }
};